module.exports = __webpack_public_path__ + "static/media/fullscreen.552d00a8.png";